import { useState } from 'react'
import { I18n } from 'aws-amplify'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { Cell, Row } from '@/primitives'
import { Select } from '@/elements'

import { showBanner } from '@/slices/util'
import { deleteSensorEnrollment } from '@/api/management/sensorEnrollment'

import Strings from '../Strings'

const ACTION_EDIT = 'edit'
const ACTION_DELETE = 'delete'

const SensorEnrollmentsListItem = ({ enrollment, onRefresh }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const [isDeleting, setIsDeleting] = useState(false)

  const strings = Strings()

  const actions = [
    {
      label: strings.editButton,
      value: ACTION_EDIT
    },
    {
      label: strings.deleteButton,
      value: ACTION_DELETE
    }
  ]

  async function handleDelete() {
    if (
      !window.confirm(
        I18n.get('Are you sure you want to delete this enrollment?')
      )
    ) {
      return
    }

    setIsDeleting(true)
    try {
      const { error } = await deleteSensorEnrollment({
        enrollmentId: enrollment.id
      })

      if (error) {
        dispatch(
          showBanner({
            show: true,
            message: error,
            type: 'error'
          })
        )
      } else {
        dispatch(
          showBanner({
            show: true,
            message: I18n.get('Enrollment deleted successfully'),
            type: 'success'
          })
        )
        onRefresh()
      }
    } catch (err) {
      dispatch(
        showBanner({
          show: true,
          message: err.message || I18n.get('An error occurred'),
          type: 'error'
        })
      )
    } finally {
      setIsDeleting(false)
    }
  }

  function handleEdit() {
    history.push(`/admin/ops/${enrollment.id}/edit`)
  }

  function onSelectAction({ value }) {
    switch (value) {
      case ACTION_EDIT:
        handleEdit()
        break
      case ACTION_DELETE:
        handleDelete()
        break
      default:
        break
    }
  }

  return (
    <Row key={enrollment.id}>
      <Cell>{enrollment.id}</Cell>
      <Cell>{enrollment.organization?.name || enrollment.organizationId}</Cell>
      <Cell>{enrollment.roleName}</Cell>
      <Cell>{enrollment.deviceIds?.length || 0}</Cell>
      <Cell>
        {enrollment.signupsCount} / {enrollment.maxSignups}
      </Cell>
      <Cell>
        <Select
          classNamePrefix='EnrollmentAction__Select'
          placeholder={I18n.get('Options')}
          onChange={onSelectAction}
          options={actions}
          isDisabled={isDeleting}
        />
      </Cell>
    </Row>
  )
}

export default SensorEnrollmentsListItem
